import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getTasks } from "api";
import { userQueryKeys } from "./userQueryKeys";

const useGetTasks = (options?: UseQueryOptions) =>
  useQuery<any>({
    queryKey: [userQueryKeys.taskWidget],
    queryFn: () => getTasks().then((res) => res.data),
    staleTime: 300000,
    ...options,
  });

export default useGetTasks;
